import { render, staticRenderFns } from "./subproduct.vue?vue&type=template&id=2ae6d491&lang=html"
import script from "./subproduct.vue?vue&type=script&lang=js"
export * from "./subproduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports